import { useEffect, useRef } from 'react';
import { getAssetUrl } from "@/utils/common";
// import { useStore } from "@/store";
import { useDigitalStore } from '@/store/digital';
// import { DigitalHumanMode } from "@/store/types";

const AudioPlayer = () => {
  const audioRef = useRef<HTMLAudioElement>(null);
  // const digitalHumanMode = useStore((state) => state.digitalHumanMode);
  const isIdle = useDigitalStore((state) => state.isIdle);

  // console.log('isIdle',isIdle);

  useEffect(() => {
    if (audioRef.current) {
      if (!isIdle) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
    }
  }, [isIdle]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.5;
    }
  }, []);

  return (
    <audio 
      ref={audioRef}
      src={getAssetUrl("videos/silent/audio.mp3")} 
      autoPlay 
      loop 
    />
  );
};

export default AudioPlayer; 